class MockThemeService {
    getSkinFormSections(skinName) {
        switch (skinName) {
            case 'nostro':
                return this.getNostroFormSections();
            case 'winning':
                return this.getWinningFormSections();
            default:
                console.log(`unknown skin name: ${skinName}`);
                return {
                    sections: []
                };
        }
    }

    getNostroFormSections() {
        return {
            sections: [
                displaySizeSection,
                skinOptionsSection,
                mascotSection,
                fontSelectionSection,
                fontSizeSection,
                nostroColorSection,
                borderSection,
                widgetPositionSection,
            ]
        };
    }

    getWinningFormSections() {
        return {
            sections: [
                displaySizeSection,
                skinOptionsSection,
                mascotSection,
                fontSelectionSection,
                fontSizeSection,
                winningColorSection,
                widgetPositionSection,
            ]
        };
    }
}

// Form sections

const displaySizeSection = {
    label: 'Display Size',
    fields: [
        { label: 'Display width (pixels)', kind: 'number', name: 'display_width' },
        { label: 'Display height (pixels)', kind: 'number', name: 'display_height' }
    ]
};

const skinOptionsSection = {
    label: 'Skin Options',
    fields: [
        {
            label: 'Skin name', kind: 'select', name: 'skin_name',
            options: [
                { label: 'Nostro', value: 'nostro' },
                { label: 'Winning', value: 'winning' },
            ]
        },
        {
            label: 'Layout type', kind: 'select', name: 'layout_type',
            options: [
                { label: 'Seven inch', value: 'seven_inch' },
                // { label: 'Planner', value: 'planner' },
                // { label: 'Small', value: 'small' },
            ]
        },
        {
            label: 'Planner day event count',
            kind: 'number',
            name: 'planner_day_event_count',
        }
    ]
};

const mascotSection = {
    label: 'Mascot',
    fields: [
        {
            label: 'Mascot type', kind: 'select', name: 'mascot_type',
            options: [
                { label: 'Light', value: 'light' },
                { label: 'Dark', value: 'dark' },
            ]
        },
        { label: 'Mascot height when alone (pixels)', kind: 'pixel', name: 'fortune_mascot_height' },
        { label: 'Mascot height in event (pixels)', kind: 'pixel', name: 'event_mascot_height' },
    ]
};

const fontSelectionSection = {
    label: 'Font Selection',
    fields: [
        {
            label: 'Main font', kind: 'select', name: 'main_font',
            options: [
                { label: "Seven Segment © Krafti Lab", value: "Seven Segment" },
                { label: "Titillium Web © Accademia di Belle Arti di Urbino", value: "Titillium Web" },
                { label: "Chicago FLF © Robin Casady", value: "Chicago FLF" },
                { label: "Good Old DOS © Daymarius", value: "Good Old DOS" },
                { label: "ZXDTPAc © softhouse.speccy.cz", value: "ZXDTPAc" },
                { label: "W95 FA © Fonts Arena", value: "W95 FA" },
                { label: "MicroKnight Plus © Niels Krogh Mortensen", value: "MicroKnight Plus" },
                { label: "MicroKnight © Niels Krogh Mortensen", value: "MicroKnight" },
                { label: "Sans Serif", value: "sans-serif" },
                { label: "Serif", value: "serif" },
                { label: "Monospace", value: "monospace" },
            ]
        },
        {
            label: 'Time font', kind: 'select', name: 'time_font',
            options: [
                { label: "Seven Segment © Krafti Lab", value: "Seven Segment" },
                { label: "Titillium Web © Accademia di Belle Arti di Urbino", value: "Titillium Web" },
                { label: "Chicago FLF © Robin Casady", value: "Chicago FLF" },
                { label: "Good Old DOS © Daymarius", value: "Good Old DOS" },
                { label: "ZXDTPAc © softhouse.speccy.cz", value: "ZXDTPAc" },
                { label: "W95 FA © Fonts Arena", value: "W95 FA" },
                { label: "MicroKnight Plus © Niels Krogh Mortensen", value: "MicroKnight Plus" },
                { label: "MicroKnight © Niels Krogh Mortensen", value: "MicroKnight" },
                { label: "Sans Serif", value: "sans-serif" },
                { label: "Serif", value: "serif" },
                { label: "Monospace", value: "monospace" },
            ]
        }
    ]
};

const fontSizeSection = {
    label: 'Font Sizes',
    fields: [
        { label: 'Default Font Size', kind: 'point', name: 'body_font_size' },
        { label: 'Date Font Size', kind: 'point', name: 'date_font_size' },
        { label: 'Time Font Size', kind: 'point', name: 'time_font_size' },
        { label: 'Current Weather Font Size', kind: 'point', name: 'current_weather_font_size' },
        { label: 'Default Button Font Size', kind: 'point', name: 'action_button_font_size' },
        { label: 'Switcher-Widget Button Font Size', kind: 'point', name: 'switcher_button_font_size' },
        { label: 'Astronomy Font Size', kind: 'point', name: 'astro_font_size' },
        { label: 'Weather Data Font Size', kind: 'point', name: 'weather_data_font_size' },
        { label: 'Current Weather Icon Font Size', kind: 'point', name: 'current_weather_icon_font_size' },
        { label: 'Forecast Icon Font Size', kind: 'point', name: 'forecast_icon_font_size' },
        { label: 'Forecast Table Icon Font Size', kind: 'point', name: 'forecast_table_icon_font_size' },
        { label: 'Forecast Control Button Font Size', kind: 'point', name: 'forecast_control_button_font_size' },
        { label: 'Forecast Control Label Font Size', kind: 'point', name: 'forecast_control_label_font_size' },
        { label: 'Calendar Day Date Font Size', kind: 'point', name: 'calendar_day_date_font_size' },
        { label: 'Calendar Day Font Size', kind: 'point', name: 'calendar_day_font_size' },
        { label: 'Event Calendar Control Button Font Size', kind: 'point', name: 'event_calendar_control_button_font_size' },
        { label: 'Fortune Message Font Size', kind: 'point', name: 'fortune_message_font_size' },
        { label: 'Next Event Time Font Size', kind: 'point', name: 'next_event_time_font_size' },
        { label: 'Next Event Text Font Size', kind: 'point', name: 'next_event_text_font_size' },
        { label: 'Loading Grid Font Size', kind: 'point', name: 'loading_grid_font_size' },
        { label: 'Planner Day Font Size', kind: 'point', name: 'planner_date_cell_font_size' },
        { label: 'Status Note Font Size', kind: 'point', name: 'status_note_font_size' },
    ]
};

const nostroColorSection = {
    label: 'Colors',
    fields: [
        { label: 'Foreground Color', kind: 'color', name: 'foreground_color' },
        { label: 'Background Color', kind: 'color', name: 'background_color' },
        { label: 'Box Background Color', kind: 'color', name: 'box_background_color' },
        { label: 'Box Border Color', kind: 'color', name: 'box_border_color' },
        { label: 'Time Color', kind: 'color', name: 'time_color' },
        { label: 'Button Border Color', kind: 'color', name: 'button_border_color' },
        { label: 'Button Foreground Color', kind: 'color', name: 'button_foreground_color' },
        { label: 'Button Background Color', kind: 'color', name: 'button_background_color' },
        { label: 'Disabled Button Border Color', kind: 'color', name: 'disabled_button_border_color' },
        { label: 'Disabled Button Foreground Color', kind: 'color', name: 'disabled_button_foreground_color' },
        { label: 'Disabled Button Background Color', kind: 'color', name: 'disabled_button_background_color' },
        { label: 'Error Symbol Color', kind: 'color', name: 'error_color' },
    ]
};

const winningColorSection = {
    label: 'Colors',
    fields: [
        { label: 'Time Color', kind: 'color', name: 'time_color' },
        { label: 'Error Symbol Color', kind: 'color', name: 'error_color' },
    ]
};

const borderSection = {
    label: 'Borders',
    fields: [
        { label: 'Box Border Radius (pixels)', kind: 'pixel', name: 'box_border_radius' },
        { label: 'Box Border Width (pixels)', kind: 'pixel', name: 'box_border_width' },
        { label: 'Button Border Radius (pixels)', kind: 'pixel', name: 'button_border_radius' },
        { label: 'Button Border Width (pixels)', kind: 'pixel', name: 'button_border_width' },
    ]
};

const widgetPositionSection = {
    label: 'Widget Positions',
    fields: [
        { label: 'Widget-Switcher Left (pixels)', kind: 'pixel', name: 'widget_switcher_x' },
        { label: 'Widget-Switcher Top (pixels)', kind: 'pixel', name: 'widget_switcher_y' },
        { label: 'Widget-Switcher Width (pixels)', kind: 'pixel', name: 'widget_switcher_width' },
        { label: 'Widget-Switcher Height (pixels)', kind: 'pixel', name: 'widget_switcher_height' },
        { label: 'Date-Time Left (pixels)', kind: 'pixel', name: 'date_time_x' },
        { label: 'Date-Time Top (pixels)', kind: 'pixel', name: 'date_time_y' },
        { label: 'Date-Time Width (pixels)', kind: 'pixel', name: 'date_time_width' },
        { label: 'Date-Time Height (pixels)', kind: 'pixel', name: 'date_time_height' },
        { label: 'Action Center Left (pixels)', kind: 'pixel', name: 'action_center_x' },
        { label: 'Action Center Top (pixels)', kind: 'pixel', name: 'action_center_y' },
        { label: 'Action Center Width (pixels)', kind: 'pixel', name: 'action_center_width' },
        { label: 'Action Center Height (pixels)', kind: 'pixel', name: 'action_center_height' },
        { label: 'Planner Left (pixels)', kind: 'pixel', name: 'planner_x' },
        { label: 'Planner Top (pixels)', kind: 'pixel', name: 'planner_y' },
        { label: 'Planner Width (pixels)', kind: 'pixel', name: 'planner_width' },
        { label: 'Planner Height (pixels)', kind: 'pixel', name: 'planner_height' },
        { label: 'Planner Date Cell Width (pixels)', kind: 'pixel', name: 'planner_date_cell_width' },
        { label: 'Planner Date Cell Height (pixels)', kind: 'pixel', name: 'planner_date_cell_height' },
    ]
};

// Export
export const Service = new MockThemeService();
